import React from 'react';
import { useNavigate } from 'react-router-dom';
import { X, Calendar, Users, Award, TrendingUp } from 'lucide-react';
interface RewardDetailDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  reward: {
    id: number;
    name: string;
    status: string;
    redemptions: number;
    diamondsSpent: number;
    lastRedemption: string;
    category: string;
    availability: number;
    totalAvailability: number;
  } | null;
}
const RewardDetailDrawer: React.FC<RewardDetailDrawerProps> = ({
  isOpen,
  onClose,
  reward
}) => {
  const navigate = useNavigate();
  if (!reward) return null;
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'Attivo':
        return 'bg-green-100 text-green-800';
      case 'In Scadenza':
        return 'bg-amber-100 text-amber-800';
      case 'Esaurito':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  const handleViewDetails = () => {
    navigate(`/rewards/${reward.id}`);
    onClose();
  };
  return <>
      {/* Backdrop */}
      {isOpen && <div className="fixed inset-0 bg-black/20 backdrop-blur-sm z-40" onClick={onClose} data-id="element-1068"></div>}

      {/* Drawer */}
      <div className={`fixed top-0 right-0 h-full w-full sm:w-96 bg-white shadow-xl z-50 overflow-y-auto transition-transform duration-300 ease-in-out ${isOpen ? 'transform-none' : 'translate-x-full'}`} data-id="element-1069">
        <div className="p-6" data-id="element-1070">
          {/* Header */}
          <div className="flex items-center justify-between mb-6" data-id="element-1071">
            <h2 className="text-xl font-semibold" data-id="element-1072">Dettagli Premio</h2>
            <button onClick={onClose} className="rounded-full p-2 hover:bg-gray-100 transition-colors" data-id="element-1073">
              <X className="h-5 w-5 text-gray-500" data-id="element-1074" />
            </button>
          </div>

          {/* Reward Info */}
          <div className="space-y-6" data-id="element-1075">
            {/* Name and Status */}
            <div data-id="element-1076">
              <h3 className="text-lg font-medium mb-2" data-id="element-1077">{reward.name}</h3>
              <span className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${getStatusColor(reward.status)}`} data-id="element-1078">
                {reward.status}
              </span>
            </div>

            {/* Category */}
            <div className="flex items-center text-sm text-gray-600" data-id="element-1079">
              <Award className="h-4 w-4 mr-2" data-id="element-1080" />
              <span data-id="element-1081">Categoria: {reward.category}</span>
            </div>

            {/* Stats Grid */}
            <div className="grid grid-cols-2 gap-4" data-id="element-1082">
              <div className="p-4 bg-gray-50 rounded-lg" data-id="element-1083">
                <div className="flex items-center text-gray-500 text-xs mb-1" data-id="element-1084">
                  <TrendingUp className="h-3 w-3 mr-1" data-id="element-1085" />
                  Riscatti
                </div>
                <div className="text-2xl font-semibold" data-id="element-1086">
                  {reward.redemptions}
                </div>
              </div>
              <div className="p-4 bg-gray-50 rounded-lg" data-id="element-1087">
                <div className="flex items-center text-gray-500 text-xs mb-1" data-id="element-1088">
                  <Award className="h-3 w-3 mr-1" data-id="element-1089" />
                  Diamond Spesi
                </div>
                <div className="text-2xl font-semibold" data-id="element-1090">
                  {reward.diamondsSpent}
                </div>
              </div>
            </div>

            {/* Availability */}
            <div data-id="element-1091">
              <div className="flex justify-between text-sm mb-2" data-id="element-1092">
                <span className="text-gray-600" data-id="element-1093">Disponibilità</span>
                <span className="font-medium" data-id="element-1094">
                  {reward.availability} / {reward.totalAvailability}
                </span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-1095">
                <div className="bg-greenback rounded-full h-2" style={{
                width: `${reward.availability / reward.totalAvailability * 100}%`
              }} data-id="element-1096"></div>
              </div>
            </div>

            {/* Last Redemption */}
            <div className="flex items-center text-sm text-gray-600" data-id="element-1097">
              <Calendar className="h-4 w-4 mr-2" data-id="element-1098" />
              <span data-id="element-1099">Ultimo riscatto: {reward.lastRedemption}</span>
            </div>

            {/* Actions */}
            <div className="pt-4 border-t border-gray-200" data-id="element-1100">
              <button onClick={handleViewDetails} className="w-full px-4 py-2 bg-greenback text-white rounded-full hover:bg-greenback-600 transition-colors" data-id="element-1101">
                Vedi Dettagli Premio
              </button>
            </div>
          </div>
        </div>
      </div>
    </>;
};
export default RewardDetailDrawer;